<app-set-or-reset-password-step1 *ngIf="isStep1"></app-set-or-reset-password-step1>
<app-set-or-reset-password-step2 *ngIf="!isStep1"></app-set-or-reset-password-step2>
